import { HttpClient } from '@angular/common/http';
import { computed, inject, Injectable, signal } from '@angular/core';


import { AuthResponse } from '../interfaces/auth-response.interface';
import { catchError, map, Observable, of, tap } from 'rxjs';
import { rxResource } from '@angular/core/rxjs-interop';
import { Router } from '@angular/router';
import { User } from '../interfaces/user.interface';
import { environment } from 'src/environments/environment';
import { API_ENDPOINTS } from 'src/app/core/constants/api-endpoints.constant';
import { Module } from '@features/admin/modules/interfaces/module.interface';
import { MenuItem } from 'primeng/api';
import { ServerResponse } from 'src/app/core/interfaces/server.interface';

type AuthStatus = 'checking' | 'authenticated' | 'not-authenticated';
const baseUrl = environment.baseUrl;

@Injectable({ providedIn: 'root' })
export class AuthService {
    private _authStatus = signal<AuthStatus>('checking');
    private _user = signal<User | null>(null);
    private _token = signal<string | null>(localStorage.getItem('access_token'));
    private _expires_in = signal<string | null>(localStorage.getItem('expires_in'))
    private http = inject(HttpClient);
    private router = inject(Router);
    private refreshing = false;
    private pendingRequests: Array<() => void> = [];


    checkStatusResource = rxResource({
        loader: () => this.checkAuthStatus()
    })

    authStatus = computed<AuthStatus>(() => {
        if (this._authStatus() == 'checking') return 'checking';

        if (this._user()) {
            return 'authenticated'
        }

        return 'not-authenticated';

    });

    user = computed<User | null>(() => this._user());
    token = computed(this._token);



    login(username: string, password: string): Observable<boolean> {

        return this.http.post<{ data: AuthResponse }>(`${baseUrl}${API_ENDPOINTS.LOGIN}`, {
            email: username, password: password
        }).pipe(
            map(resp => this.handleAuthSuccess(resp.data)),
            catchError((error: any) => this.handleAuthError(error))
        );
    }

    checkAuthStatus(): Observable<boolean> {

        const token = localStorage.getItem('access_token');
        const expiresIn = localStorage.getItem('expires_in');
        const user = localStorage.getItem('user');
        if (!token || !expiresIn || this.isTokenExpired()) {
            this.logout();
            return of(false);
        }
        this._authStatus.set('authenticated');
        this._token.set(token);
        this._user.set(user ? JSON.parse(user) : null);
        return of(true);

    }

    logout() {
        this._authStatus.set('not-authenticated');
        this._token.set(null);
        this._user.set(null);
        localStorage.removeItem('access_token');
        localStorage.removeItem('expires_in');
        localStorage.removeItem('user');
        this.router.navigate(['/auth/login']);
    }

    private handleAuthSuccess({ user, access_token, expires_in }: AuthResponse) {
        const expirationDate = new Date(Date.now() + Number(expires_in * 1000))
        this._user.set(user);
        this._authStatus.set('authenticated');
        this._token.set(access_token);
        this._expires_in.set(expirationDate.toISOString());

        localStorage.setItem('access_token', access_token);
        localStorage.setItem('expires_in', expirationDate.toISOString());
        localStorage.setItem('user', JSON.stringify(user));
        return true;
    }

    private handleAuthError(error: any) {
        this.logout();
        return of(false);
    }

    private isTokenExpired(): boolean {
        const expiresIn = this._expires_in();
        if (!expiresIn) return true;

        const now = new Date();
        const expiresAt = new Date(expiresIn);

        return now >= expiresAt;
    }




    // refreshToken(): Observable<boolean> {
    //     if (this.refreshing) {
    //         return new Observable((observer) => {
    //             this.pendingRequests.push(() => observer.next(true));
    //         });
    //     }

    //     this.refreshing = true;

    //     const refresh_token = localStorage.getItem('refresh_token');
    //     if (!refresh_token) {
    //         this.logout();
    //         return of(false);
    //     }

    //     return this.http.post<{ data: Token }>(`${baseUrl}/auth/refresh-token`, { refresh_token })
    //         .pipe(
    //             map(resp => {

    //                 const { token, expires_in } = resp.data;

    //                 this._token.set(token);


    //                 localStorage.setItem('token', token);


    //                 this.refreshing = false;

    //                 // Ejecutar peticiones en espera
    //                 this.pendingRequests.forEach(cb => cb());
    //                 this.pendingRequests = [];

    //                 return true;
    //             }),
    //             catchError(_ => {
    //                 this.refreshing = false;
    //                 this.pendingRequests = [];
    //                 this.logout();
    //                 return of(false);
    //             })
    //         );
    // }


    setUserPermissions(permissions: string[]) {
        const currentUser = this._user();
        if (!currentUser) return;

        const updatedUser = { ...currentUser, permissions };
        this._user.set(updatedUser);
        localStorage.setItem('user', JSON.stringify(updatedUser));
    }


    getModules(): Observable<ServerResponse> {
        return this.http.get<ServerResponse>(`${baseUrl}/${API_ENDPOINTS.AUTH}`)
    }


}

